import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  getVarsomeHost,
  getGenomeName,
} from "../../../../../state/selectors/general.selectors";
import HelperText from "../../../../../components/atoms/HelperText";
import GnomadEntry from "../GnomadEntry";

function TranscriptGnomadTable({ varsomeHost, genomeName, gnomadEntry, gene }) {
  return (
    <div className="tw-mt-4">
      <table className="varsome-table tw-break-words">
        <thead>
          <tr>
            <th className="tw-font-bold tw-text-center">Gene Symbol</th>
            <th className="tw-font-bold tw-text-center">
              BioType
              <HelperText fieldDescriptionKey="BioType" />
            </th>
            <th className="tw-font-bold tw-text-center">
              Transcript ID
              <HelperText fieldDescriptionKey="Transcript" />
            </th>
            <th className="tw-font-bold tw-text-center">
              Coding exons
              <HelperText fieldDescriptionKey="Coding exons" />
            </th>
            <th className="tw-font-bold tw-text-center">
              Coding Sequence Length
              <HelperText fieldDescriptionKey="Length" />
            </th>
          </tr>
        </thead>
        <tbody className="varsome-text-center">
          <tr>
            <td className="tw-text-center">{gene || "-"}</td>
            <td className="tw-text-center">
              {gnomadEntry.transcriptType || "-"}
            </td>
            <td className="tw-text-center">
              {gnomadEntry.transcript ? (
                <a
                  href={`${varsomeHost}/transcript/${genomeName}/${gnomadEntry.transcript}`}
                >
                  {gnomadEntry.transcript}
                </a>
              ) : (
                "-"
              )}
            </td>
            <td className="tw-text-center">
              {gnomadEntry.numCodingExons || "-"}
            </td>
            <td className="tw-text-center">{gnomadEntry.cdsLength || "-"}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

TranscriptGnomadTable.propTypes = {
  gene: PropTypes.string,
  gnomadEntry: PropTypes.instanceOf(GnomadEntry),
  varsomeHost: PropTypes.string.isRequired,
  genomeName: PropTypes.string.isRequired,
};

TranscriptGnomadTable.defaultProps = {
  gene: "",
  gnomadEntry: null,
};

const mapStateToProps = (state) => ({
  varsomeHost: getVarsomeHost(state),
  genomeName: getGenomeName(state),
});

export default connect(mapStateToProps)(TranscriptGnomadTable);
